/**
 * **Herkunft einer importierten Zeile** — `importedFrom` an Aufgabe,
 * Unteraufgabe, Projekt, Abschnitt und Tag, z. B. `todoist:6Jf8VQXxpwv56VQ7`.
 * **Testdaten** (#269) tragen `testdata:<lauf>:<n>`, auch an Zielen und Gewohnheiten.
 * Die **Einführung** (#323) trägt `intro:sample:<n>` am Beispielprojekt und `intro:learn:<schritt>` an
 * den Lernaufgaben — eigene Quelle, damit „Testdaten entfernen“ sie nicht mitnimmt.
 *
 * Ein Feld statt zwei: Die Quelle steht vorn, damit ein zweiter Anbieter kein
 * neues Feld braucht (docs/concept/todoist-import.md).
 */
export type ImportSource = 'todoist' | 'testdata' | 'intro'

const SOURCES: readonly ImportSource[] = ['todoist', 'testdata', 'intro']

export function formatImportedFrom(source: ImportSource, id: string): string {
  return `${source}:${id}`
}

/** Zerlegt einen gespeicherten Wert; fremde oder kaputte Werte geben `null`. */
export function parseImportedFrom(value: string | null | undefined): { source: ImportSource; id: string } | null {
  if (!value) return null
  const colon = value.indexOf(':')
  if (colon <= 0) return null
  const source = value.slice(0, colon)
  const id = value.slice(colon + 1)
  if (!id || !(SOURCES as readonly string[]).includes(source)) return null
  return { source: source as ImportSource, id }
}

/** Beispielprojekt und Lernaufgaben der Einführung (#323) machen die App nicht „voll“ — Import und Backup bleiben. */
export function isIntroContent(row: { importedFrom?: string | null }): boolean {
  return row.importedFrom?.startsWith('intro:') === true
}
